import PropTypes from 'prop-types';
import React from 'react';

import localize from 'components/Localize/Localize';
import StarryBackground from 'components/StarryBackground/StarryBackground';

import styles from './HundredNightTrial.css';
import translations from './translations';

class HundredNightTrial extends React.Component {
  renderTrialBlocks() {
    const blockType = this.props.t.products[this.props.productType].blockType;

    return this.props.t.blockTypes[blockType].map((block, i) => {
      return (
        <div
          className={styles[`block`]}
          key={i}
        >
          <div className={styles[`block-image-wrapper`]}>
            <img
              alt={block.imageAlt}
              className={styles[`block-image`]}
              src={`/assets-spa/images/${block.imagePath}`}
            />
          </div>
          <p className={styles[`block-content`]}>
            {block.content}
          </p>
        </div>
      );
    });
  }

  render() {
    const product = this.props.t.products[this.props.productType];

    return (
      <section className={styles[`container`]}>
        <StarryBackground />
        <div className={styles[`content`]}>
          <h2 className={styles[`heading`]}>{product.heading}</h2>
          <p className={styles[`sub-heading`]}>{product.subHeading}</p>
          <div className={styles[`blocks-container`]}>
            {this.renderTrialBlocks()}
          </div>
        </div>
      </section>
    );
  }
}

HundredNightTrial.propTypes = {
  productType: PropTypes.string.isRequired,
  t: PropTypes.shape({
    blockTypes: PropTypes.object.isRequired,
    products: PropTypes.objectOf(PropTypes.shape({
      heading: PropTypes.string.isRequired,
      subHeading: PropTypes.string.isRequired,
    })).isRequired,
  }),
};

export default localize(HundredNightTrial, translations);
